import { IAppState } from '../../redux';
import { IServicePeriod } from '../../redux/reducers';

export function selectPublicationPeriod(state: IAppState): IServicePeriod | null {
  return state.publishTerms.publication.period;
}
